import React, { useState, useRef } from 'react';
import './hidescrollbarx.css';

function LatestEvents() {
    const [sessions, setSessions] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9, 10]);
    const scrollContainerRef = useRef(null);
    // handle scroll left
    const scrollLeft = () => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollBy({
                left: -300,
                behavior: 'smooth',
            });
        }
    };
    // handle scroll left
    const scrollRight = () => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollBy({
                left: 300, 
                behavior: 'smooth',
            });
        }
    };
    
    return (
        <div className='flex flex-row'>
            <div className='w-1/12 flex justify-center items-center' >
                <i className="fa-solid fa-chevron-left fa-xl" onClick={scrollLeft} style={{cursor:'pointer'}} title='Scroll Left'></i>
            </div>

            <div className="flex flex-col m-auto p-auto w-10/12" style={{ fontFamily: "Ropa Sans" }}>
                <h1 className="flex py-5 font-bold text-4xl  lg:justify-start justify-center" style={{color:'#001F33'}}>
                    Latest Events
                </h1>
                <div className="flex overflow-x-scroll pb-10 hide-scroll-bar" ref={scrollContainerRef}>
                    <div className="flex flex-nowrap mt-10">
                        {sessions.map(eventvalues => (
                            <div className="inline-block me-20" key={eventvalues}>
                                <div className="w-64 h-96 max-w-xs overflow-hidden -lg -md hover:shadow-xl transition-shadow duration-300 ease-in-out">
                                    <img src="https://th.bing.com/th/id/OIP._K1Mx169DW56Srekn5ulvwHaK0?rs=1&pid=ImgDetMain" title={`Event ${eventvalues}`} style={{ width: '100%', height: '90%' ,}} alt={`Event${eventvalues}`} />
                                    <div className='flex flex-row justify-between'>
                                        <h2 className='ms-2 mt-1' style={{color:'#001F33'}}>Event {eventvalues}</h2>
                                        <h5 className='me-2 text-xs items-center mt-2 text-slate-500'>jan 21 - 2024</h5>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className='w-1/12 flex justify-center items-center' >
            <i class="fa-solid fa-chevron-right fa-xl " title='Scroll Right' onClick={scrollRight} style={{cursor:'pointer'}}></i>
            </div>

        </div>
    );
}

export default LatestEvents;
